import moment from 'moment';
import { DATE_REQUEST } from '@/helpers/common';

export const getPeriodOptions = t => {
  const now = moment();
  const quarter = now.quarter();

  const startDate = moment()
    .quarter(quarter)
    .startOf('quarter')
    .format(DATE_REQUEST);
  const endDate = moment()
    .quarter(quarter)
    .endOf('quarter')
    .format(DATE_REQUEST);

  return [
    {
      label: t('reports:period_select.last_7_days'),
      value: `${moment().subtract(1, 'week').format(DATE_REQUEST)}:${moment().format(DATE_REQUEST)}`,
    },
    {
      label: t('reports:period_select.last_30_days'),
      value: `${moment().subtract(1, 'month').format(DATE_REQUEST)}:${moment().format(DATE_REQUEST)}`,
    },
    {
      label: t('reports:period_select.this_month'),
      value: `${moment().startOf('month').format(DATE_REQUEST)}:${moment().endOf('month').format(DATE_REQUEST)}`,
    },
    {
      label: t('reports:period_select.this_quarter'),
      value: `${startDate}:${endDate}`,
    },
    {
      label: t('reports:period_select.this_year'),
      value: `${moment().startOf('year').format(DATE_REQUEST)}:${moment().endOf('year').format(DATE_REQUEST)}`,
    },
  ];
};
